import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehouseForm from "./warehouseComponents/WarehouseForm";

import { useAddWarehouseMutation } from "store/services/warehouseApi";

const WarehouseCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehouses", path: "/app/crm/warehouse/list" },
    { title: "New Warehouse" },
  ];

  //rtk query
  const [addWarehouse, { isLoading }] = useAddWarehouseMutation();

  const handleCreateWarehouse = async (data) => {
    try {
      const { _id } = await addWarehouse(data).unwrap();
      toast.success("Warehouse successfully created!");
      navigate(`/app/crm/warehouse/${_id}/detail`);//changed lateley
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create warehouse!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <WarehouseForm isBusy={isLoading} onSubmit={handleCreateWarehouse} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseCreateScreen;
